import { render } from "./TrainingProgramComponent.vue?vue&type=template&id=1d23a8c8&scoped=true"
import script from "./TrainingProgramComponent.vue?vue&type=script&lang=js"
export * from "./TrainingProgramComponent.vue?vue&type=script&lang=js"

import "./TrainingProgramComponent.vue?vue&type=style&index=0&id=1d23a8c8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d23a8c8"]])

export default __exports__